






























































































import { Component, Vue } from 'vue-property-decorator'
import api from '@/services/api'
import chat from '@/services/chat'
import { take } from 'rxjs/operators'
import { Subscription } from 'rxjs'

import Message from '@/components/Message.vue'

const emojiNameMap = {
    '✈️': 'airplane',
    '⏰': 'alarm_clock',
    '👽': 'alien',
    '🚗': 'automobile',
    '👇': 'backhand_index_pointing_down',
    '👈': 'backhand_index_pointing_left',
    '👉': 'backhand_index_pointing_right',
    '👆': 'backhand_index_pointing_up',
    '😁': 'beaming_face_with_smiling_eyes',
    '🎂': 'birthday_cake',
    '💣': 'bomb',
    '🍾': 'bottle_with_popping_cork',
    '🎳': 'bowling',
    '💔': 'broken_heart',
    '🦋': 'butterfly',
    '📸': 'camera_with_flash',
    '😹': 'cat_with_tears_of_joy',
    '✅': 'check_mark_button',
    '🎄': 'christmas_tree',
    '🎬': 'clapper_board',
    '👏': 'clapping_hands',
    '🍻': 'clinking_beer_mugs',
    '🥂': 'clinking_glasses',
    '🥶': 'cold_face',
    '💥': 'collision',
    '🎊': 'confetti_ball',
    '🤠': 'cowboy_hat_face',
    '🐮': 'cow_face',
    '🤞': 'crossed_fingers',
    '👑': 'crown',
    '😢': 'crying_face',
    '🏝️': 'desert_island',
    '🎯': 'direct_hit',
    '😵': 'dizzy_face',
    '🐶': 'dog_face',
    '🤤': 'drooling_face',
    '🥁': 'drum',
    '🤯': 'exploding_head',
    '👀': 'eyes',
    '😘': 'face_blowing_a_kiss',
    '😱': 'face_screaming_in_fear',
    '🤮': 'face_vomiting',
    '🤕': 'face_with_head_bandage',
    '🧐': 'face_with_monocle',
    '🙄': 'face_with_rolling_eyes',
    '😤': 'face_with_steam_from_nose',
    '🤬': 'face_with_symbols_on_mouth',
    '😂': 'face_with_tears_of_joy',
    '🤒': 'face_with_thermometer',
    '🧚': 'fairy',
    '🎡': 'ferris_wheel',
    '🔥': 'fire',
    '🎆': 'fireworks',
    '🚒': 'fire_engine',
    '🐟': 'fish',
    '🎣': 'fishing_pole',
    '⛳': 'flag_in_hole',
    '💪': 'flexed_biceps',
    '😳': 'flushed_face',
    '🛸': 'flying_saucer',
    '🐸': 'frog',
    '☹️': 'frowning_face',
    '👻': 'ghost',
    '😄': 'grinning_face_with_smiling_eyes',
    ' ': 'grinning_squinting_face',
    '💗': 'growing_heart',
    '🍔': 'hamburger',
    '🤝': 'handshake',
    '💘': 'heart_with_arrow',
    '🙉': 'hear_no_evil_monkey',
    '🚁': 'helicopter',
    '🐝': 'honeybee',
    '🐎': 'horse',
    '☕': 'hot_beverage',
    '🥵': 'hot_face',
    '🤗': 'hugging_face',
    '💯 ': 'hundred_points',
    '😯': 'hushed_face',
    '🎃': 'jack_o_lantern',
    '🦘': 'kangaroo',
    '💋': 'kiss_mark',
    '💡': 'light_bulb',
    '🚂': 'locomotive',
    '😭': 'loudly_crying_face',
    '🤟': 'love_you_gesture',
    '🤥': 'lying_face',
    '🚴‍♂️': 'man_biking',
    '🕺': 'man_dancing',
    ' ‍♂️': 'man_facepalming',
    '🧚‍♂️': 'man_fairy',
    '🤹‍♂️': 'man_juggling',
    '🙋‍♂️': 'man_raising_hand',
    '🏃‍♂️': 'man_running',
    '🤷‍♂️': 'man_shrugging',
    '💁‍♂️': 'man_tipping_hand',
    '🧟‍♂️': 'man_zombie',
    '👯‍♂️': 'men_with_bunny_ears',
    '🖕': 'middle_finger',
    '🤑': 'money_mouth_face',
    '💸': 'money_with_wings',
    '🎶': 'musical_notes',
    '🤓': 'nerd_face',
    '👊': 'oncoming_fist',
    '🚔': 'oncoming_police_car',
    '🦉': 'owl',
    '🥞': 'pancakes',
    '🥳': 'partying_face',
    '🎉': 'party_popper',
    '☮️': 'peace_symbol',
    '🐧': 'penguin',
    '👯': 'people_with_bunny_ears',
    '🚴': 'person_biking',
    '🤦': 'person_facepalming',
    '🤹': 'person_juggling',
    '🙋': 'person_raising_hand',
    '🏃': 'person_running',
    '🤷': 'person_shrugging',
    '💁': 'person_tipping_hand',
    '🐷': 'pig_face',
    '💩': 'pile_of_poo',
    '🔫': 'pistol',
    '🥺': 'pleading_face',
    '🚨': 'police_car_light',
    '🍿': 'popcorn',
    '😡': 'pouting_face',
    '🚫': 'prohibited',
    '🐰': 'rabbit_face',
    '🏳️‍🌈': 'rainbow_flag',
    '🙌': 'raising_hands',
    '😌': 'relieved_face',
    '💞': 'revolving_hearts',
    '💍': 'ring',
    '🤖': 'robot',
    '🚀': 'rocket',
    '🎢': 'roller_coaster',
    '🤣': 'rolling_on_the_floor_laughing',
    '🐓': 'rooster',
    '🥪': 'sandwich',
    '🎅': 'santa_claus',
    '🙈': 'see_no_evil_monkey',
    '🤫': 'shushing_face',
    '😴': 'sleeping_face',
    '🦥': 'sloth',
    '🎰': 'slot_machine',
    '☺️': 'smiling_face',
    '😇': 'smiling_face_with_halo',
    '🥰': 'smiling_face_with_hearts',
    '😍': 'smiling_face_with_heart_eyes',
    '😈': 'smiling_face_with_horns',
    '😎': 'smiling_face_with_sunglasses',
    '😏': 'smirking_face',
    '🐍': 'snake',
    '🤧': 'sneezing_face',
    '☃️': 'snowman',
    '⚽': 'soccer_ball',
    '✨': 'sparkles',
    '💖': 'sparkling_heart',
    '🙊': 'speak_no_evil_monkey',
    '🚙': 'sport_utility_vehicle',
    '🐳': 'spouting_whale',
    '🤩': 'star_struck',
    '☀️': 'sun',
    '🌅': 'sunrise',
    '🧸': 'teddy_bear',
    '🤔': 'thinking_face',
    '💭': 'thought_balloon',
    '👎': 'thumbs_down',
    '👍': 'thumbs_up',
    '🌪️': 'tornado',
    '🏆': 'trophy',
    '☔': 'umbrella_with_rain_drops',
    '😒': 'unamused_face',
    '  ': 'unicorn',
    '🙃': 'upside_down_face',
    '🎻': 'violin',
    '🌋': 'volcano',
    '⚠️': 'warning',
    '👋': 'waving_hand',
    '😩': 'weary_face',
    '😉': 'winking_face',
    '😜': 'winking_face_with_tongue',
    '🚴‍♀️': 'woman_biking',
    '💃': 'woman_dancing',
    '🤦‍♀️': 'woman_facepalming',
    '🧚‍♀️': 'woman_fairy',
    '🤹‍♀️': 'woman_juggling',
    '🙋‍♀️': 'woman_raising_hand',
    '🏃‍♀️': 'woman_running',
    '🤷‍♀️': 'woman_shrugging',
    '💁‍♀️': 'woman_tipping_hand',
    '🧟‍♀️': 'woman_zombie',
    '👯‍♀️': 'women_with_bunny_ears',
    '🥴': 'woozy_face',
    '✍️': 'writing_hand',
    '🥱': 'yawning_face',
    '🤪': 'zany_face',
    '🤐': 'zipper_mouth_face',
    '🧟': 'zombie',
}

@Component({
    components: {
        Message,
    },
})
export default class extends Vue {
    message = ''
    messages: any[] = []
    disableTopLoadMessages: boolean
    subscriptions: Subscription[] = []

    created() {
        this.subscriptions.push(
            chat.messages.subscribe(this.onMessage.bind(this))
        )

        setTimeout(() => {
            // this.$router.push('/chat/gifs');
        }, 5000)

        this.loadMessages()
    }
    destroyed() {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    async loadMessages(skip = 0, mode = 'append') {
        chat.loadMessages(skip, mode).subscribe(message => {
            this.onMessage(message, mode)
        })
    }
    async onMessage(msg: any, mode = 'append') {
        const user = await api.user.pipe(take(1)).toPromise()
        const message = {
            ...msg,
            me: user._id === msg.f,
        }
        if (this.messages.includes(message)) {
            // debugger;
        }
        if (this.messages.find(m => m._id === message.Id)) {
            // debugger;
        }
        if (mode === 'append') {
            this.messages.push(message)
        } else {
            this.messages.unshift(message)
        }
        setTimeout(() => {
            this.calculateHeight()
        }, 0)
    }
    calculateHeight() {
        const messages = (this.$refs.message as any[]).map(
            vue => vue.$refs.root
        ) as HTMLElement[]
        const container = this.$refs['message-container'] as HTMLElement
        if (messages.length < 20) {
            const messageHeight = messages
                .map(el => el.offsetHeight)
                .reduce((a, b) => a + b, 0)
            ;(this.$refs
                .spacer as HTMLElement).style.height = `${container.offsetHeight -
                messageHeight}px`
        }
        // messages.slice(-1)[0].scrollIntoView()
        container.scrollTo({
            top: container.scrollHeight,
        })
        setTimeout(() => {
            this.scrollToBottom();
        }, 0)
    }
    onFocusTextarea() {
        this.scrollToBottom();
        setTimeout(() => {
            this.scrollToBottom();
        });
        setTimeout(() => {
            this.scrollToBottom();
        }, 1000);
    }
    scrollToBottom() {
        const container = this.$refs['message-container'] as HTMLElement
        container.scrollTo({
            top: container.scrollHeight,
        })
    }
    textareaInput(ev: KeyboardEvent) {
        const target = ev.target as HTMLElement
        target.style.height = 'auto'
        target.style.height = target.scrollHeight + 'px'
    }
    sendMessageFromEvent(event: KeyboardEvent) {
        event.preventDefault()
        const emojiRegex = /^[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}\u{200d}]*$/gu
        const message = this.message.trim()
        this.message = ''

        // check whether we have an animated version
        if (Object.prototype.hasOwnProperty.call(emojiNameMap, message)) {
            chat.sendMessage(undefined, [
                {
                    t: 'ae',
                    d: (emojiNameMap as any)[message],
                },
            ])
        } else if (message.length > 0 && emojiRegex.test(message)) {
            chat.sendMessage(undefined, [
                {
                    t: 'e',
                    d: message,
                },
            ])
        } else if (message.length > 0) {
            console.log('abc', message.length)
            chat.sendMessage(message)
        }
        (this.$refs.textarea as HTMLTextAreaElement).focus();
    }

    async handleDrop(event: DragEvent) {
        const items = Array.from(event?.dataTransfer?.items || [])
        event.preventDefault()
        this.handleDataTransferItems(items)
    }
    async handlePaste(event: ClipboardEvent) {
        const items = Array.from(event.clipboardData?.items || [])
        this.handleDataTransferItems(items)
    }
    async handleDataTransferItems(items: DataTransferItem[]) {
        const imageItems = items.filter(item =>
            ['image/png', 'image/gif'].includes(item.type)
        )
        const imageBlobs = imageItems.map(imageItem =>
            imageItem.getAsFile()
        ) as File[]
        const size = imageBlobs
            .map(blob => blob.size)
            .reduce((a, b) => a + b, 0)
        if (size > 900000) {
            alert('size too big, sorry :( ' + size)
            return
        }
        // const user = await api.user.pipe(take(1)).toPromise()
        // const result = await api.service('messages').create({
        //     f: user._id,
        //     to: user.partner,
        //     t: new Date().getTime(),
        //     m: 'image',
        //     mm: [
        //         {t: 'i', d: imageBlobs[0]}
        //     ]
        // })
        const base64strings = await Promise.all(
            imageBlobs.map(blob => {
                return new Promise(resolve => {
                    const reader = new FileReader()
                    reader.readAsDataURL(blob)
                    reader.onloadend = function() {
                        const base64data = reader.result
                        resolve(base64data)
                    }
                })
            })
        )
        for (const image of base64strings) {
            chat.sendMessage(undefined, [
                {
                    t: 'i',
                    d: image,
                },
            ])
        }
        // console.log(base64strings);
    }
    onMessageContainerScroll() {
        if (this.disableTopLoadMessages) {
            return
        }
        this.disableTopLoadMessages = true
        const container = this.$refs['message-container'] as HTMLElement
        if (container.scrollTop === 0) {
            this.loadMessages(this.messages.length, 'prepend')
        }
        this.disableTopLoadMessages = false
    }
}
